(function(){
  function label(src){try{var h=new URL(src,location.href).hostname.replace(/^www\./,'');return h?'Embedded content from '+h:'Embedded content'}catch(e){return 'Embedded content'}}
  var UC_CSS=':focus-visible{outline:2px solid #111!important;outline-offset:2px!important;box-shadow:0 0 0 4px #fff!important}'+
    'button[aria-label*="slide"]{min-width:24px!important}'+
    '.UpcartDesignSettings__cartTextSubduedColor,.UpcartDesignSettings__cartTextSubduedColor *{color:#4a4a4a!important;opacity:1!important}'+
    '.styles_TrashButton__deleteButton__{min-width:24px;min-height:24px;display:inline-flex;align-items:center;justify-content:center;cursor:pointer}';
  var lastFocus=null,wasOpen=false,ut;
  function txt(el){return el?(el.textContent||'').replace(/\s+/g,' ').trim():''}
  function rowTitle(el){var p=el;while(p&&p.parentElement){p=p.parentElement;var t=p.querySelector&&p.querySelector('.upcart-product-title-link');if(t)return txt(t)}return ''}
  function set(el,a,v){if(el&&el.getAttribute(a)!==v)el.setAttribute(a,v)}
  function fixUpcart(){
    var host=document.getElementById('upCart'),r=host&&host.shadowRoot;if(!r)return;
    if(!r.__a11y){r.__a11y=1;
      var st=document.createElement('style');st.textContent=UC_CSS;r.appendChild(st);
      new MutationObserver(function(){clearTimeout(ut);ut=setTimeout(fixUpcart,120)}).observe(r,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
      r.addEventListener('keydown',function(e){
        var t=e.target,panel=r.querySelector('.upcart-cart');
        if((e.key==='Enter'||e.key===' ')&&t.getAttribute&&t.getAttribute('role')==='button'&&t.tagName!=='BUTTON'){e.preventDefault();t.click();return}
        if(!r.querySelector('.upcartPopupShow')||!panel)return;
        if(e.key==='Escape'){var c=r.querySelector('[aria-label="Close cart"]');if(c){e.preventDefault();c.click()}return}
        if(e.key==='Tab'){
          var f=[].filter.call(panel.querySelectorAll('a[href],button,input:not([type=hidden]),select,textarea,[tabindex]'),function(x){return x.tabIndex>=0&&!x.disabled&&!x.closest('[inert],[aria-hidden=true]')&&x.getClientRects().length});
          if(!f.length)return;var a=r.activeElement;
          if(e.shiftKey&&(a===f[0]||!panel.contains(a))){e.preventDefault();f[f.length-1].focus()}
          else if(!e.shiftKey&&(a===f[f.length-1]||!panel.contains(a))){e.preventDefault();f[0].focus()}
        }
      },true);
    }
    var open=!!r.querySelector('.upcartPopupShow'),panel=r.querySelector('.upcart-cart');
    if(panel&&panel.inert===open)panel.inert=!open;var hh=r.querySelector('h2.upcart-header-text');if(hh)set(hh,'tabindex','-1');if(panel){set(panel,'role','dialog');set(panel,'aria-label','Shopping cart');if(open)set(panel,'aria-modal','true');else panel.removeAttribute('aria-modal')}
    r.querySelectorAll('.styles_TrashButton__deleteButton__').forEach(function(d){set(d,'role','button');set(d,'tabindex','0');set(d,'aria-label','Remove '+(rowTitle(d)||'item')+' from cart')});
    r.querySelectorAll('.upcart-product-quantity-input').forEach(function(i){var n=rowTitle(i);if(n){set(i,'aria-label','Quantity for '+n)}});
    r.querySelectorAll('.upcart-product-quantity-minus').forEach(function(b){var n=rowTitle(b);if(n)set(b,'aria-label','Decrease quantity for '+n)});
    r.querySelectorAll('.upcart-product-quantity-plus,[class*=quantityPlus]').forEach(function(b){var n=rowTitle(b);if(n)set(b,'aria-label','Increase quantity for '+n)});
    r.querySelectorAll('.upcart-upsell-item-card').forEach(function(card){
      var links=card.querySelectorAll('a[href]'),title='';
      links.forEach(function(a){if(!title&&txt(a))title=txt(a)});
      links.forEach(function(a){if(!txt(a)){set(a,'aria-hidden','true');set(a,'tabindex','-1')}});
      var s=card.querySelector('select');if(s)set(s,'aria-label','Choose style, color and size for '+(title||'this design'));
      var b=card.querySelector('.upcart-upsells-button');if(b)set(b,'aria-label','Add '+(title||'this design')+' to cart');
    });
    /* upsell slide inert/aria-hidden handled by a11y-uc-carousel-v1 */
    if(open&&!wasOpen){wasOpen=true;setTimeout(function(){var p=r.querySelector('.upcart-cart');if(p&&!p.contains(r.activeElement)){var h=r.querySelector('h2.upcart-header-text')||r.querySelector('[aria-label="Close cart"]');if(h)h.focus()}},400)}
    else if(!open&&wasOpen){wasOpen=false;var ae=document.activeElement;if((!ae||ae===document.body||ae===host)&&lastFocus&&document.contains(lastFocus))lastFocus.focus()}
  }
  document.addEventListener('focusin',function(e){var h=document.getElementById('upCart');if(!h||(e.target!==h&&!h.contains(e.target)))lastFocus=e.target},true);
  function fix(){
    document.querySelectorAll('iframe').forEach(function(f){
      if((f.getAttribute('title')||'').trim()||f.getAttribute('aria-label'))return;
      var tiny=f.offsetWidth<2&&f.offsetHeight<2;
      f.setAttribute('title',tiny?'Background service frame':label(f.src));
      if(tiny){f.setAttribute('aria-hidden','true');f.setAttribute('tabindex','-1')}
    });
    var c=document.getElementById('upCart');
    if(c&&!c.hasAttribute('role')){c.setAttribute('role','region');c.setAttribute('aria-label','Shopping cart')}
    fixUpcart();
  }
  var t;function safeFix(){try{fix()}catch(e){}}
  new MutationObserver(function(){clearTimeout(t);t=setTimeout(safeFix,250)}).observe(document.documentElement,{childList:true,subtree:true});
  safeFix();
})();

/* a11y-manual-v1 */
(function(){
  function set(el,a,v){if(el&&el.getAttribute(a)!==v)el.setAttribute(a,v)}
  var PAUSE='<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M4.5 2v10M9.5 2v10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var PLAY='<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M4 2.2l7.5 4.8L4 11.8z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  function annPause(){
    var wrap=document.querySelector('.announcement-bar-slider');if(!wrap||wrap.querySelector('.a11y-ann-pause'))return;
    var sc=wrap;while(sc&&typeof sc.pause!=='function')sc=sc.parentElement;
    if(!sc||!sc.slider||sc.slider.getAttribute('data-autoplay')!=='true')return;
    var b=document.createElement('button');b.type='button';b.className='a11y-ann-pause';b.setAttribute('aria-label','Pause announcements');b.innerHTML=PAUSE;var paused=false;
    b.addEventListener('click',function(){paused=!paused;if(paused){sc.autoplayButtonIsSetToPlay=false;sc.pause()}else{sc.autoplayButtonIsSetToPlay=true;sc.play()}b.setAttribute('aria-label',paused?'Play announcements':'Pause announcements');b.innerHTML=paused?PLAY:PAUSE});
    wrap.appendChild(b);
  }
  function tips(){
    document.querySelectorAll('.bulk-tooltip-trigger').forEach(function(t){
      if(t.__a11y)return;var tp=t.querySelector('.bulk-tooltip');if(!tp)return;t.__a11y=1;
      if(!tp.id)tp.id='bulk-tip-'+Math.random().toString(36).slice(2,8);
      set(t,'tabindex','0');set(t,'role','button');set(t,'aria-expanded','false');set(t,'aria-controls',tp.id);
      var cl=tp.querySelector('.bulk-tooltip-close');if(cl){set(cl,'role','button');set(cl,'aria-label','Close price details');set(cl,'tabindex','0')}
      function show(v){tp.style.visibility=v?'visible':'hidden';tp.style.opacity=v?'1':'0';t.setAttribute('aria-expanded',v?'true':'false')}
      t.addEventListener('keydown',function(e){
        if(e.key==='Escape'){show(false);t.focus();return}
        if(e.key!=='Enter'&&e.key!==' ')return;e.preventDefault();
        if(cl&&e.target===cl){show(false);t.focus();return}
        show(t.getAttribute('aria-expanded')!=='true');
      });
      t.addEventListener('focusout',function(e){if(!t.contains(e.relatedTarget))show(false)});
    });
  }
  document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('.bulk-tooltip').forEach(function(tp){if(tp.style.visibility==='visible'){tp.style.visibility='hidden';tp.style.opacity='0';var t=tp.closest('.bulk-tooltip-trigger');if(t)t.setAttribute('aria-expanded','false')}})});
  var scLast=null,scWasOpen=false;
  function sizeChart(){
    var m=document.getElementById('size-chart-modal');if(!m)return;
    document.querySelectorAll('.sc-tab').forEach(function(b){set(b,'aria-pressed',b.classList.contains('active')?'true':'false')});
    m.querySelectorAll('table').forEach(function(tb){var first=tb.querySelector('tr');tb.querySelectorAll('th').forEach(function(th){set(th,'scope',th.parentElement===first?'col':'row')})});
    var open=!!m.getClientRects().length&&getComputedStyle(m).visibility!=='hidden';
    if(open)scWasOpen=true;
    else if(scWasOpen){scWasOpen=false;var ae=document.activeElement;if((!ae||ae===document.body||!ae.getClientRects().length)&&scLast&&document.contains(scLast))scLast.focus()}
  }
  document.addEventListener('click',function(e){var t=e.target.closest&&e.target.closest('.sc-trigger');if(t)scLast=t;if(e.target.closest&&e.target.closest('.sc-tab,.sc-trigger,.sc-modal__close'))setTimeout(sizeChart,30)},true);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')setTimeout(sizeChart,60)},true);
  function forms(){
    [['contact[name]','name'],['contact[email]','email'],['contact[phone]','tel'],['customer[first_name]','given-name'],['customer[last_name]','family-name'],['customer[email]','email']].forEach(function(p){document.querySelectorAll('input[name="'+p[0]+'"]').forEach(function(i){if(!i.getAttribute('autocomplete'))i.setAttribute('autocomplete',p[1])})});
  }
  document.addEventListener('focusin',function(e){
    var t=e.target;if(!t||!t.getBoundingClientRect||t===document.body||(t.closest&&t.closest('.section-header,#upCart,[role=dialog],dialog')))return;
    var h=document.querySelector('.section-header');if(!h)return;
    requestAnimationFrame(function(){var hb=h.getBoundingClientRect().bottom,r=t.getBoundingClientRect();if(hb>0&&r.bottom>0&&r.top<hb+4)window.scrollBy(0,r.top-hb-16)});
  });
  function run(){annPause();tips();sizeChart();forms()}
  var q;new MutationObserver(function(){clearTimeout(q);q=setTimeout(run,300)}).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

/* a11y-manual-v2 */
(function(){
  function dedupe(){
    document.querySelectorAll('.card__media > a[href]').forEach(function(a){
      if(a.__a11y)return;var card=a.closest('.card-wrapper,.card,.product-card-wrapper')||a.parentElement.parentElement.parentElement;
      var dup=card&&[].some.call(card.querySelectorAll('a[href]'),function(o){return o!==a&&o.getAttribute('href')===a.getAttribute('href')});
      if(!dup)return;a.__a11y=1;a.setAttribute('tabindex','-1');a.setAttribute('aria-hidden','true');
    });
  }
  var q;new MutationObserver(function(){clearTimeout(q);q=setTimeout(dedupe,300)}).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',dedupe);else dedupe();
})();

/* a11y-manual-v3 */
(function(){
  function set(el,a,v){if(el&&el.getAttribute(a)!==v)el.setAttribute(a,v)}
  var FOC='a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function vis(el){return el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden'}
  /* Mobile drawer: inert when closed, focus trap + Esc when open */
  function drawer(){
    var p=document.getElementById('SixdsDrawerPanel');if(!p||p.__a11y)return;p.__a11y=1;
    var sync=function(){p.inert=!p.classList.contains('is-open')};sync();
    new MutationObserver(sync).observe(p,{attributes:true,attributeFilter:['class']});
    document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-sd-open],.sixds-drawer__toggle'))p.inert=false},true);
    document.addEventListener('keydown',function(e){
      if(!p.classList.contains('is-open'))return;
      if(e.key==='Escape'){var c=p.querySelector('[data-sd-close]');if(c){e.preventDefault();c.click()}return}
      if(e.key!=='Tab')return;
      var f=[].filter.call(p.querySelectorAll(FOC),vis);if(!f.length)return;
      var first=f[0],last=f[f.length-1],a=document.activeElement;
      if(!p.contains(a)){e.preventDefault();first.focus();return}
      if(e.shiftKey&&(a===first||a===p)){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&a===last){e.preventDefault();first.focus()}
    });
  }
  /* Rail "View All" links: unique accessible names */
  function rails(){
    document.querySelectorAll('a.vb-rail__viewall').forEach(function(a){
      if(a.getAttribute('aria-label'))return;
      var head=a.parentElement,t=head&&head.querySelector('h1,h2,h3,h4,[class*=title]');
      var txt=t&&t.textContent.trim();if(txt)a.setAttribute('aria-label','View all '+txt);
    });
  }
  /* Google rating strip outside landmarks */
  function rating(){var g=document.querySelector('.mobile-google-rating');if(g){if(g.getAttribute('role')==='region')g.removeAttribute('role');if(g.hasAttribute('aria-label')&&!g.getAttribute('role'))g.removeAttribute('aria-label')}}
  /* Desktop mega menu: disclosure navigation pattern */
  function mega(){
    var list=document.querySelector('.vb-catnav__list');if(!list||list.__a11y)return;list.__a11y=1;
    list.removeAttribute('role');
    list.querySelectorAll('[role=menu],[role=menuitem],[role=none]').forEach(function(el){el.removeAttribute('role')});
    list.querySelectorAll('a.vb-catnav__col-head[href="#"]').forEach(function(h){h.removeAttribute('href');set(h,'role','heading');set(h,'aria-level','2')});
    list.querySelectorAll('.vb-catnav__item--has-children').forEach(function(li){
      var t=li.querySelector(':scope > .vb-catnav__link'),m=li.querySelector(':scope > .vb-catnav__mega');if(!t||!m)return;
      t.removeAttribute('aria-haspopup');
      if(!m.id)m.id='vb-mega-'+Math.random().toString(36).slice(2,8);set(t,'aria-controls',m.id);
      var upd=function(){setTimeout(function(){var open=li.matches(':hover,:focus-within')&&!li.classList.contains('a11y-closed');set(t,'aria-expanded',open?'true':'false')},20)};
      ['mouseenter','mouseleave','focusin','focusout'].forEach(function(ev){li.addEventListener(ev,upd)});
      li.addEventListener('mouseleave',function(){li.classList.remove('a11y-closed');upd()});
      li.addEventListener('focusout',function(e){if(!li.contains(e.relatedTarget)){li.classList.remove('a11y-closed');upd()}});
      li.addEventListener('keydown',function(e){
        if(e.key==='Escape'){li.classList.add('a11y-closed');t.focus();upd()}
        else if((e.key==='ArrowDown'||e.key==='Enter'&&e.target!==t)&&li.classList.contains('a11y-closed')){li.classList.remove('a11y-closed');upd()}
      });
      set(t,'aria-expanded','false');
    });
  }
  /* UpCart: colors + select label */
  var UC3='[class*=cartDiscountFormat],.upcart-product-savings{color:#1d7a44!important}[class*=PreviewCarousel__button],.upcart-upsells-button,[class*=CustomButton__fullWidth]{background:#1d7a44!important;border-color:#1d7a44!important;color:#fff!important}';
  function upcart(){
    var h=document.getElementById('upCart'),r=h&&h.shadowRoot;if(!r)return;
    if(!r.querySelector('style[data-a11y-v3]')){var s=document.createElement('style');s.setAttribute('data-a11y-v3','');s.textContent=UC3;r.appendChild(s)}
    r.querySelectorAll('select[title=productVariant]').forEach(function(sel){
      if(sel.getAttribute('aria-label'))return;
      var card=sel.closest('[class*=upsell-item-card]')||sel.parentElement;var nm=card&&card.querySelector('[class*=title],[class*=name]');
      sel.setAttribute('aria-label','Choose variant'+(nm&&nm.textContent.trim()?' for '+nm.textContent.trim():''));
    });
  }
  /* Respect reduced motion: start announcements paused */
  function annReduce(){
    if(!window.matchMedia||!matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var b=document.querySelector('.a11y-ann-pause');if(b&&!b.__rm&&b.getAttribute('aria-label')==='Pause announcements'){b.__rm=1;b.click()}
  }
  function run(){drawer();rails();rating();mega();upcart();annReduce()}
  var q;new MutationObserver(function(){clearTimeout(q);q=setTimeout(run,300)}).observe(document.documentElement,{childList:true,subtree:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

/* a11y-audit-v1 */
(function(){
  var d=document;
  function $(s,r){return (r||d).querySelector(s)}
  function $$(s,r){return [].slice.call((r||d).querySelectorAll(s))}
  function set(el,a,v){if(el&&el.getAttribute(a)!==v)el.setAttribute(a,v)}
  function sr(txt,cls){var s=d.createElement('span');s.className='a11y-sr visually-hidden '+(cls||'');s.textContent=txt;return s}
  var live;function announce(msg){if(!live){live=d.createElement('div');live.className='a11y-v4-live visually-hidden';live.setAttribute('aria-live','polite');live.setAttribute('role','status');d.body.appendChild(live)}live.textContent='';setTimeout(function(){live.textContent=msg},60)}

  /* H2 countdown: no live region on a per-second clock */
  function countdown(){$$('.teetime-countdown[role],.teetime-countdown[aria-live]').forEach(function(e){e.removeAttribute('role');e.removeAttribute('aria-live')})}

  /* H3 cart link name with count */
  function cart(){var a=d.getElementById('cart-icon-bubble');if(!a)return;var b=a.querySelector('.cart-count-bubble [aria-hidden=true]')||a.querySelector('.cart-count-bubble');var n=b?parseInt(b.textContent,10)||0:0;set(a,'aria-label','Cart'+(n>0?', '+n+(n===1?' item':' items'):''))}

  /* H4 prices read as $9.99, deal template gets Regular/Sale labels */
  function prices(){
    $$('.price-item').forEach(function(p){
      if(p.querySelector('.a11y-price'))return;
      var raw=p.textContent.replace(/\s+/g,'');if(!/^\$\d/.test(raw))return;
      var cs=p.querySelector('sup.cents-sup,sup.price-cents'),c=cs?cs.textContent.replace(/\D/g,''):'';
      var txt=c&&raw.slice(-c.length)===c?raw.slice(0,raw.length-c.length)+'.'+c:raw;
      [].slice.call(p.childNodes).forEach(function(n){
        if(n.nodeType===3){if(n.textContent.trim()){var w=d.createElement('span');w.setAttribute('aria-hidden','true');p.insertBefore(w,n);w.appendChild(n)}}
        else if(n.nodeType===1)n.setAttribute('aria-hidden','true');
      });
      p.insertBefore(sr(txt,'a11y-price'),p.firstChild);
    });
    $$('.price__sale').forEach(function(s){
      var lab=function(el){var p=el&&el.previousElementSibling;return p&&p.classList.contains('visually-hidden')};
      var c=$('s.compare-at-price',s),sale=$('.price-item--sale:not(.deal-price)',s);
      if(c&&!lab(c))s.insertBefore(sr('Regular price '),c);
      if(sale&&!lab(sale))s.insertBefore(sr('Sale price '),sale);
    });
  }

  /* H5 "See all categories": Escape + focus-out close, state exposed */
  function mega(){
    var w=d.getElementById('shop-by-cat');if(!w||w.__a11ya)return;w.__a11ya=1;
    var t=$('.mega-trigger',w),p=$('.mega-panel',w);if(!t||!p)return;
    if(!p.id)p.id='a11y-mega-panel';set(t,'aria-controls',p.id);t.removeAttribute('aria-haspopup');p.removeAttribute('role');
    var open=function(){return getComputedStyle(p).display!=='none'};
    /* a11y-mega-fit-v1: keep the panel inside the viewport (it ran 63px past the edge at 1280px) */
    var fit=function(){p.style.translate='';var r=p.getBoundingClientRect();if(!r.width)return;var vw=d.documentElement.clientWidth,dx=0;if(r.right>vw-12)dx=vw-12-r.right;if(r.left+dx<12)dx=12-r.left;if(dx)p.style.translate=Math.round(dx)+'px 0'};
    var sync=function(){var o=open();set(t,'aria-expanded',o?'true':'false');if(o){p.removeAttribute('aria-hidden');fit()}else set(p,'aria-hidden','true')};
    var later=function(){setTimeout(sync,60)};
    var close=function(f){w.classList.remove('is-open');w.classList.add('a11y-closed');sync();if(f)t.focus()};
    w.addEventListener('keydown',function(e){if(e.key==='Escape'&&open()){e.preventDefault();e.stopPropagation();close(true)}});
    /* a11y-mega-esc-v1: Escape also dismisses a hover-opened panel (1.4.13), and Tabbing out always closes it */
    d.addEventListener('keydown',function(e){if(e.key==='Escape'&&open()&&!w.contains(d.activeElement))close(false)});
    w.addEventListener('focusout',function(e){if(!w.contains(e.relatedTarget)&&open())close(false)});
    addEventListener('resize',function(){if(open())fit()});
    w.addEventListener('mouseleave',function(){w.classList.remove('a11y-closed');later()});
    w.addEventListener('mouseenter',later);
    t.addEventListener('click',function(){w.classList.remove('a11y-closed');later()},true);
    t.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){w.classList.remove('a11y-closed');later()}},true);
    new MutationObserver(later).observe(w,{attributes:true,attributeFilter:['class']});
    sync();
  }

  /* H7 style switcher + B1 colour swatches expose selected state */
  function pressed(){
    $$('.pdp-style-subtab').forEach(function(b){set(b,'aria-pressed',b.classList.contains('is-active')?'true':'false')});
    $$('.vb-ss__swatches').forEach(function(g){set(g,'role','group');set(g,'aria-label','Color')});
    $$('.vb-ss__swatch').forEach(function(b){set(b,'aria-pressed',b.classList.contains('is-selected')?'true':'false');if(b.title)set(b,'aria-label',b.title)});
  }

  /* H8 + L1 hero: offer text as alt, slide-wide duplicate link out of tab order */
  function hero(){
    var s=$('.slideshow__slide img');if(s&&s.alt==='Slideshow banner')s.alt='Tees just $6.99 when you buy 10 or more';
    /* a11y-hero-n1-v1: whole-slide links stay out of the Tab order; no aria-hidden on a focusable link. The first slideshow-component on the page is the announcement bar, so observe every one. */
  /* a11y-hero-m-v1: on phones the slide CTA button is hidden, so the active slide's whole-slide link is its only control and must stay focusable */
  function heroLinks(root){$$('.slideshow__slide-link',root).forEach(function(a){a.removeAttribute('aria-hidden');var sl=a.closest('.slideshow__slide');var btn=sl&&sl.querySelector('.button');var only=sl&&sl.getAttribute('aria-hidden')!=='true'&&!(btn&&btn.offsetWidth);if(only){if(a.hasAttribute('tabindex'))a.removeAttribute('tabindex')}else if(a.getAttribute('tabindex')!=='-1')a.setAttribute('tabindex','-1')})}
  heroLinks(document);
  $$('slideshow-component').forEach(function(ss){if(ss.__a11y)return;ss.__a11y=1;new MutationObserver(function(){heroLinks(ss)}).observe(ss,{subtree:true,attributes:true,attributeFilter:['tabindex','aria-hidden']})});
  if(!window.__a11yHeroRs){window.__a11yHeroRs=1;addEventListener('resize',function(){heroLinks(document)})}
  }

  /* M1 + M2 landmarks */
  function landmarks(){
    var bar=$('.header .icon-bar');if(bar){set(bar,'role','navigation');set(bar,'aria-label','Primary')}
    var dn=$('.menu-drawer__navigation');if(dn)set(dn,'aria-label','Menu');
    $$('.announcement-bar__announcement[role=region],.announcement-bar [role=region]:not(.announcement-bar)').forEach(function(e){e.removeAttribute('role');e.removeAttribute('aria-label');e.removeAttribute('aria-roledescription')});
    var cn=$('vb-category-nav');if(cn){set(cn,'role','navigation');set(cn,'aria-label','Blank apparel categories')}
  }

  /* M4 Dawn mobile drawer: dialog semantics, page behind inert */
  function dawnDrawer(){
    var m=d.getElementById('menu-drawer');if(!m||m.__a11y)return;var det=m.closest('details');if(!det)return;m.__a11y=1;
    set(m,'role','dialog');set(m,'aria-modal','true');set(m,'aria-label','Menu');
    var sync=function(){var o=det.hasAttribute('open');$$('#MainContent,main,footer,.footer-group,#shopify-section-footer').forEach(function(e){if(!e.closest('header'))e.inert=o})};
    new MutationObserver(sync).observe(det,{attributes:true,attributeFilter:['open']});sync();
  }

  /* M7 duplicate zero-height product titles */
  function titles(){
    var real=$('main [role=heading][aria-level="1"]');if(!real)return;var tx=real.textContent.trim();
    $$('main h1,main h2.h1').forEach(function(h){if(h!==real&&h.offsetHeight===0&&h.textContent.trim()===tx)set(h,'aria-hidden','true')});
  }

  /* M9 aria-controls only when the results list exists in that form */
  function searchIds(){
    $$('[aria-controls="predictive-search-results"],[data-a11y-ac]').forEach(function(i){
      i.setAttribute('data-a11y-ac','1');var sc=i.closest('predictive-search,form');var t=sc&&sc.querySelector('#predictive-search-results');
      if(t)set(i,'aria-controls','predictive-search-results');else i.removeAttribute('aria-controls');
    });
  }

  /* L5 table header scope + hidden caption from preceding heading */
  function prevHeading(el){for(var n=el,k=0;n&&k<4;n=n.parentElement,k++){for(var s=n.previousElementSibling;s;s=s.previousElementSibling){var h=s.matches('h2,h3,h4,h5')?s:s.querySelector&&s.querySelector('h2,h3,h4,h5');if(h&&h.textContent.trim())return h.textContent.trim()}}return ''}
  function tables(){
    $$('table').forEach(function(t){
      if(t.__a11y||!t.rows.length)return;t.__a11y=1;
      [].forEach.call(t.rows[0].cells,function(c){if(c.tagName==='TH'&&!c.hasAttribute('scope'))c.setAttribute('scope','col')});
      [].slice.call(t.rows,1).forEach(function(r){var c=r.cells[0];if(c&&c.tagName==='TH'&&!c.hasAttribute('scope'))c.setAttribute('scope','row')});
      if(!t.caption){var h=prevHeading(t);if(h){var cap=t.createCaption();cap.className='a11y-sr visually-hidden';cap.textContent=h}}
    });
  }

  /* L7 new-tab warning, decorative star glyphs */
  function newTab(){
    $$('a[target=_blank]').forEach(function(a){
      if(a.__a11ynt)return;a.__a11ynt=1;
      var l=a.getAttribute('aria-label');if(l){if(!/new tab/i.test(l))a.setAttribute('aria-label',l+' (opens in new tab)')}
      else if(a.textContent.trim()||a.querySelector('img[alt]:not([alt=""])'))a.appendChild(sr(' (opens in new tab)'));
      $$('span,i',a).forEach(function(s){if(!s.children.length&&/^[\u2605\u2606\s]+$/.test(s.textContent))set(s,'aria-hidden','true')});
    });
  }

  /* B2 blank PDP: main image alt follows chosen colour */
  function imgAlt(){
    var n=$('[data-vb-ss-colorname]');if(!n)return;var cur=n.textContent.trim();if(!cur)return;
    var names=$$('.vb-ss__swatch').map(function(b){return (b.getAttribute('data-color')||'').trim()}).filter(Boolean).sort(function(a,b){return b.length-a.length});
    /* a11y-galt-v2: gallery alts drive the colour filter, so the spoken name goes in aria-label and alt is left alone */
    $$('.vb-ss-media img').forEach(function(i){
      var alt=i.alt||'';if(alt.indexOf(' - ')<0)return;
      if(alt.indexOf(cur)>=0){if(i.hasAttribute('aria-label'))i.removeAttribute('aria-label');return}
      for(var k=0;k<names.length;k++){if(alt.indexOf(' '+names[k]+' ')>=0||alt.indexOf('- '+names[k])>=0){set(i,'aria-label',alt.replace(names[k],cur));return}}
    });
    $$('main img').forEach(function(i){
      if(i.closest('.vb-card,.card,[class*=rail],[class*=upsell],.vb-ss-media,.product__media-list,.thumbnail-list'))return; /* a11y-galt-v1: gallery alts drive the colour filter, never rewrite them */
      var alt=i.alt||'';if(alt.indexOf(' - ')<0||alt.indexOf(cur)>=0)return;
      for(var k=0;k<names.length;k++){if(alt.indexOf(' '+names[k]+' ')>=0||alt.indexOf('- '+names[k])>=0){i.alt=alt.replace(names[k],cur);break}}
    });
  }

  /* B3 category bar column titles one level down, closed panels hidden from AT */
  function catnav(){
    /* a11y-catnav-b3-v2: column titles are labels inside the nav, not page headings */
    $$('.vb-catnav__col-head[role=heading]').forEach(function(h){h.removeAttribute('role');h.removeAttribute('aria-level')});
    $$('.vb-catnav__link[aria-controls]').forEach(function(t){var p=d.getElementById(t.getAttribute('aria-controls'));if(!p)return;
      if(t.getAttribute('aria-expanded')==='true')p.removeAttribute('aria-hidden');else set(p,'aria-hidden','true');
      if(!t.__a11yo){t.__a11yo=1;new MutationObserver(catnav).observe(t,{attributes:true,attributeFilter:['aria-expanded']})}});
  }

  /* B5 filter results announced, focus kept, Filters button refocused on close */
  var lastCount;
  function filterCount(){var c=$('.vb-grid__count');if(!c)return;var t=c.textContent.replace(/\s+/g,' ').trim();if(lastCount!==undefined&&t!==lastCount)announce(t);lastCount=t}
  d.addEventListener('change',function(e){
    var i=e.target;if(!i.matches||!i.matches('#vb-filters input, [class*=vb-filters] input'))return;
    var nm=i.name,val=i.value;
    setTimeout(function(){if(d.activeElement===d.body||!d.activeElement){var m=$$('#vb-filters input, [class*=vb-filters] input').filter(function(x){return x.name===nm&&x.value===val})[0];if(m)m.focus()}},450);
  },true);
  function filtersReturn(){setTimeout(function(){var a=d.activeElement,f=$('#vb-filters');if(f&&a&&f.contains(a)&&!a.getClientRects().length){var b=$('[data-vb-filters-open]');if(b)b.focus()}},120)}
  d.addEventListener('keydown',function(e){if(e.key==='Escape')filtersReturn()},true);
  d.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-vb-filters-close]'))filtersReturn()},true);

  /* B6 size grid: price + stock tied to each quantity input */
  function sizeGrid(){
    $$('.vb-ss__card').forEach(function(c,k){
      var i=$('.vb-ss__qty',c);if(!i||i.__a11y)return;i.__a11y=1;var ids=[];
      ['.vb-ss__price','.vb-ss__stock'].forEach(function(s,j){var e=$(s,c);if(e){if(!e.id)e.id='a11y-ss-'+k+'-'+j;ids.push(e.id)}});
      if(ids.length)i.setAttribute('aria-describedby',ids.join(' '));
    });
  }

  /* B7 "Show all / Show less" name matches state */
  function showAll(){
    $$('.vb-filters__showall').forEach(function(b){var cl=$('.vb-filters__showall-close',b);if(!cl)return;
      var openTxt=cl.textContent.trim(),closed=b.textContent.replace(openTxt,'').trim();
      set(b,'aria-label',b.getAttribute('aria-expanded')==='true'?openTxt:closed);});
  }

  /* B9 collection-card colour dots get a text list */
  function cardSwatches(){
    $$('.vb-card__swatches').forEach(function(r){if(r.querySelector('.a11y-sw'))return;
      var n=$$('.vb-card__swatch[title]',r).map(function(s){return s.title});if(!n.length)return;
      $$('.vb-card__swatch',r).forEach(function(s){set(s,'aria-hidden','true')});
      r.appendChild(sr('Colors: '+n.join(', '),'a11y-sw'));});
  }

  /* M5 UpCart: spoken cart updates, cloned carousel slides hidden */
  /* a11y-uc-live-v2: composed sentence, never container textContent */
  var lastCart='',liveClr;
  function ucOwnText(el){var s='';(function walk(n){for(var c=n.firstChild;c;c=c.nextSibling){if(c.nodeType===3)s+=c.nodeValue;else if(c.nodeType===1&&!/^(STYLE|SCRIPT|TEMPLATE)$/.test(c.tagName))walk(c)}})(el);return s.replace(/\s+/g,' ').trim()}
  function ucCheckout(r){
    var a=r.querySelector('a[class*="CustomButton__fullWidth"]');if(a)return a;
    var all=r.querySelectorAll('a[href],button');for(var i=0;i<all.length;i++){if(/^checkout/i.test(ucOwnText(all[i])))return all[i]}
    return null;
  }
  function cartSummary(r){
    var n=null,hs=r.querySelectorAll('h1,h2,h3');
    for(var i=0;i<hs.length;i++){var m=/your cart\s*\((\d+)\)/i.exec(ucOwnText(hs[i]));if(m){n=parseInt(m[1],10);break}}
    if(n===null)return '';
    var co=ucCheckout(r),tm=co&&/\$[\d,]+(?:\.\d{2})?/.exec(ucOwnText(co));
    return 'Cart updated: '+n+(n===1?' item':' items')+(tm?', total '+tm[0]:'')+'.';
  }
  function ucAnnounce(r){
    var dlg=r.querySelector('[role=dialog]')||r.firstElementChild;if(!dlg)return;
    var reg=r.querySelector('[data-a11y-live]');
    if(!reg){reg=d.createElement('div');reg.setAttribute('data-a11y-live','');reg.setAttribute('aria-live','polite');reg.style.cssText='position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';dlg.appendChild(reg)}
    var m=cartSummary(r);if(!m||m===lastCart)return;
    var first=!lastCart;lastCart=m;if(first||reg.textContent===m)return;
    reg.textContent=m;clearTimeout(liveClr);liveClr=setTimeout(function(){if(reg.textContent===m)reg.textContent=''},3000);
  }

  /* a11y-uc-carousel-v1: only the visible upsell slide is tabbable, plus a skip link to Checkout */
  var UC_SKIP_CSS='.a11y-skip-upsells{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}.a11y-skip-upsells:focus{position:relative;width:auto;height:auto;margin:0 0 8px;overflow:visible;clip:auto;white-space:normal;padding:8px 12px;background:#111;color:#fff;outline:2px solid #fff;outline-offset:-4px;border-radius:4px;font:inherit;z-index:5}';
  function ucSetAttr(el,a,v){if(el.getAttribute(a)!==v)el.setAttribute(a,v)}
  function ucDelAttr(el,a){if(el.hasAttribute(a))el.removeAttribute(a)}
  function ucApplyCarousel(r,mod,car){
    ucSetAttr(car,'role','region');ucSetAttr(car,'aria-roledescription','carousel');ucSetAttr(car,'aria-label','Other designs you might like');
    var slides=car.querySelectorAll('li.slide'),sel=car.querySelector('li.slide.selected');
    var cr=car.getBoundingClientRect(),multi=false;
    if(sel&&cr.width>0){var sw=sel.getBoundingClientRect().width;multi=sw>0&&sw<cr.width*0.6}
    for(var i=0;i<slides.length;i++){
      var li=slides[i],vis=li.classList.contains('selected');
      /* a11y-uc-carousel-v2: on first open the carousel marks the real slide AND its off-screen loop clone selected; only trust the one inside the carousel box */
      if(vis){if(cr.width>0){var sb=li.getBoundingClientRect();vis=sb.width>0&&sb.right>cr.left+1&&sb.left<cr.right-1}else vis=li===sel}
      if(!vis&&multi&&i>0&&i<slides.length-1){var lr=li.getBoundingClientRect();vis=lr.width>0&&lr.left>=cr.left-1&&lr.right<=cr.right+1}
      if(vis){ucDelAttr(li,'inert');ucDelAttr(li,'aria-hidden')}
      else{ucSetAttr(li,'inert','');ucSetAttr(li,'aria-hidden','true')}
    }
    var skip=mod.querySelector(':scope > .a11y-skip-upsells');
    if(!skip){
      skip=d.createElement('button');skip.type='button';skip.className='a11y-skip-upsells';skip.textContent='Skip recommendations and go to checkout';
      skip.addEventListener('click',function(e){e.preventDefault();var co=ucCheckout(r);if(co)co.focus()});
      mod.insertBefore(skip,mod.firstChild);
    }else if(mod.firstChild!==skip){mod.insertBefore(skip,mod.firstChild)}
    if(!r.querySelector('style[data-a11y-skip]')){var st=d.createElement('style');st.setAttribute('data-a11y-skip','');st.textContent=UC_SKIP_CSS;r.appendChild(st)}
  }
  function fixUpcartCarousel(r){
    if(!r)return;var mod=r.querySelector('#up-upsell-carousel');if(!mod)return;
    var car=mod.querySelector('.carousel-root');if(!car)return;
    var obs=car.__a11yCarObs,raf=0;
    function schedule(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;apply()})}
    function apply(){
      if(car.__a11yApplying||!car.isConnected)return;car.__a11yApplying=true;
      try{ucApplyCarousel(r,mod,car)}catch(e){}
      finally{if(car.__a11yCarObs)car.__a11yCarObs.takeRecords();car.__a11yApplying=false}
    }
    if(!obs){
      obs=new MutationObserver(function(){if(!car.__a11yApplying)schedule()});
      obs.observe(car,{attributes:true,attributeFilter:['class'],childList:true,subtree:true});
      car.__a11yCarObs=obs;
      car.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.control-arrow'))schedule()});
      car.addEventListener('transitionend',schedule);
    }
    apply();
  }

  function upcartLive(){
    var h=d.getElementById('upCart'),r=h&&h.shadowRoot;if(!r)return;
    try{fixUpcartCarousel(r)}catch(e){}
    if(r.__a11ylive)return;r.__a11ylive=1;var q,cq=0;
    new MutationObserver(function(){
      if(!cq)cq=requestAnimationFrame(function(){cq=0;try{fixUpcartCarousel(r)}catch(e){}});
      clearTimeout(q);q=setTimeout(function(){try{ucAnnounce(r)}catch(e){}},700);
    }).observe(r,{childList:true,subtree:true,characterData:true});
  }

  /* L6 404 heading: space before line break */
  function h404(){$$('main h1 br').forEach(function(b){var p=b.previousSibling;if(p&&p.nodeType===3&&!/\s$/.test(p.textContent))p.textContent+=' '})}

  function run(){[h404,countdown,cart,prices,mega,pressed,hero,landmarks,dawnDrawer,titles,searchIds,tables,newTab,imgAlt,catnav,filterCount,sizeGrid,showAll,cardSwatches,upcartLive].forEach(function(f){try{f()}catch(e){}})}
  d.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.pdp-style-subtab,.vb-ss__swatch,.vb-filters__showall'))setTimeout(run,80)},true);
  var q;new MutationObserver(function(){clearTimeout(q);q=setTimeout(run,300)}).observe(d.documentElement,{childList:true,subtree:true});
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',run);else run();
})();



/* a11y-audit-v2: approved visual/behavior fixes (H1 hero, M8 tabs, B4 blank menu, B8 add to cart, L4 form errors) */
(function(){
  var d=document,mqRM=matchMedia('(prefers-reduced-motion: reduce)'),mqDesk=matchMedia('(min-width: 750px)');

  /* H1: hero controls were hidden by the section's inline CSS; show them, slow to 6s, no autoplay under reduced motion */
  function hero(){
    d.querySelectorAll('slideshow-component').forEach(function(s){
      if(s.dataset.a11yHero||s.querySelector('.announcement-bar-slider')||s.closest('[id*=announcement],.utility-bar'))return;
      var btn=s.querySelector('.slideshow__autoplay');
      if(!btn||typeof s.play!=='function'||typeof s.togglePlayButtonState!=='function')return;
      s.dataset.a11yHero='1';
      s.classList.add('a11y-hero');
      if(s.slider)s.slider.dataset.speed='6';
      s.autoplaySpeed=6000;
      function apply(){
        s.pause();
        if(mqRM.matches){s.autoplayButtonIsSetToPlay=false;s.togglePlayButtonState(true);}
        else if(s.autoplayButtonIsSetToPlay!==false){s.play();}
      }
      apply();
      mqRM.addEventListener('change',apply);
    });
  }

  /* M8: APG tabs - roving tabindex and Arrow/Home/End */
  function tabs(){
    d.querySelectorAll('.pdp-info-tabs__nav[role=tablist],.drawer-tabs__nav[role=tablist]').forEach(function(list){
      list.querySelectorAll('[role=tab]').forEach(function(t){
        t.setAttribute('tabindex',t.getAttribute('aria-selected')==='true'?'0':'-1');
      });
      if(list.dataset.a11yTabs)return;
      list.dataset.a11yTabs='1';
      list.addEventListener('keydown',function(e){
        var cur=e.target.closest&&e.target.closest('[role=tab]');if(!cur)return;
        var ts=[].slice.call(list.querySelectorAll('[role=tab]')).filter(function(t){return t.offsetParent!==null});
        var i=ts.indexOf(cur),n=-1;
        if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%ts.length;
        else if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i-1+ts.length)%ts.length;
        else if(e.key==='Home')n=0;
        else if(e.key==='End')n=ts.length-1;
        else return;
        e.preventDefault();
        ts[n].click();ts[n].focus();
        setTimeout(tabs,0);
      });
      list.addEventListener('click',function(){setTimeout(tabs,0)});
    });
  }

  /* B4: blank category bar - panels open on Enter/Space/ArrowDown instead of on focus (desktop only) */
  function closeItem(item){
    item.classList.remove('vb-catnav__item--open');
    var l=item.querySelector('.vb-catnav__link');if(l)l.setAttribute('aria-expanded','false');
  }
  function catnav(){
    d.querySelectorAll('.vb-catnav__item--has-children > .vb-catnav__link').forEach(function(a){
      if(a.dataset.a11yKb)return;a.dataset.a11yKb='1';
      var item=a.parentElement;
      a.addEventListener('keydown',function(e){
        if(!mqDesk.matches)return;
        if(e.key!=='Enter'&&e.key!==' '&&e.key!=='ArrowDown')return;
        e.preventDefault();
        if(item.classList.contains('vb-catnav__item--open')&&e.key!=='ArrowDown'){closeItem(item);return;}
        d.querySelectorAll('.vb-catnav__item--open').forEach(function(o){if(o!==item)closeItem(o)});
        item.classList.add('vb-catnav__item--open');a.setAttribute('aria-expanded','true');
        var f=item.querySelector('.vb-catnav__mega a[href]');
        if(f)setTimeout(function(){f.focus()},40);
      });
      item.addEventListener('keydown',function(e){
        if(e.key==='Escape'&&item.classList.contains('vb-catnav__item--open')){closeItem(item);a.focus();}
      });
      item.addEventListener('focusout',function(e){
        if(!mqDesk.matches)return;
        if(e.relatedTarget&&item.contains(e.relatedTarget))return;
        if(item.matches(':hover'))return;
        closeItem(item);
      });
    });
  }

  /* B8: keep blank PDP Add to cart focusable while inactive so its instruction is announced */
  function cart(){
    d.querySelectorAll('.vb-ss__cart[data-vb-ss-add]').forEach(function(b){
      if(b.dataset.a11yAd)return;b.dataset.a11yAd='1';
      var was=b.hasAttribute('disabled');
      Object.defineProperty(b,'disabled',{configurable:true,
        get:function(){return this.getAttribute('aria-disabled')==='true'},
        set:function(v){if(v)this.setAttribute('aria-disabled','true');else this.removeAttribute('aria-disabled');}});
      b.removeAttribute('disabled');
      if(was)b.setAttribute('aria-disabled','true');
      b.addEventListener('click',function(e){
        if(b.getAttribute('aria-disabled')==='true'){e.preventDefault();e.stopImmediatePropagation();}
      },true);
    });
  }

  /* L4: inline error text for footer newsletter and contact form */
  function errId(el){if(!el.id)el.id='a11y-f-'+Math.random().toString(36).slice(2,8);return el.id+'-a11y-err';}
  function showErr(el,msg){
    var id=errId(el),p=d.getElementById(id);
    if(!p){p=d.createElement('p');p.id=id;p.className='a11y-field-error';(el.closest('.field')||el).insertAdjacentElement('afterend',p);}
    p.textContent=msg;
    el.setAttribute('aria-invalid','true');
    var db=(el.getAttribute('aria-describedby')||'').split(' ').filter(Boolean);
    if(db.indexOf(id)<0){db.push(id);el.setAttribute('aria-describedby',db.join(' '));}
  }
  function clearErr(el){
    var id=errId(el),p=d.getElementById(id);if(p)p.remove();
    el.removeAttribute('aria-invalid');
    var db=(el.getAttribute('aria-describedby')||'').split(' ').filter(function(x){return x&&x!==id});
    if(db.length)el.setAttribute('aria-describedby',db.join(' '));else el.removeAttribute('aria-describedby');
  }
  function forms(){
    d.querySelectorAll('form#ContactFooter,form#ContactForm,form.contact-form,form.newsletter-form').forEach(function(f){
      if(f.dataset.a11yErr)return;f.dataset.a11yErr='1';
      var last=0;
      f.addEventListener('invalid',function(e){
        var el=e.target;e.preventDefault();showErr(el,el.validationMessage);
        if(Date.now()-last>500){last=Date.now();el.focus();}
      },true);
      f.addEventListener('input',function(e){
        var el=e.target;if(el.getAttribute&&el.getAttribute('aria-invalid')==='true'&&el.validity&&el.validity.valid)clearErr(el);
      },true);
    });
  }

  function run(){
    [hero,tabs,catnav,cart,forms].forEach(function(fn){try{fn()}catch(e){}});
  }
  if(window.customElements)customElements.whenDefined('slideshow-component').then(function(){setTimeout(hero,0)});
  var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,300)}).observe(d.documentElement,{childList:true,subtree:true});
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',run);else run();
})();
/* a11y-cart-v4 */
(function(){
  var d=document,opener=null,wasOpen=false,intended=null,lastInside=null,tt;
  function host(){return d.getElementById('upCart')}
  function root(){var h=host();return h&&h.shadowRoot}
  function isOpen(r){return !!(r&&r.querySelector('.upcartPopupShow'))}
  function lost(){var a=d.activeElement,r=root();return !a||a===d.body||a===d.documentElement||(a===host()&&!(r&&r.activeElement))}
  function focusables(r){var p=r.querySelector('.upcart-cart');if(!p)return[];return [].filter.call(p.querySelectorAll('a[href],button,input:not([type=hidden]),select,textarea,[tabindex]'),function(x){return x.tabIndex>=0&&!x.disabled&&!x.closest('[inert],[aria-hidden=true]')&&x.getClientRects().length})}
  var intendedAt=0;
  function resolve(el){if(!el)return null;if(el.isConnected)return el;var l=el.getAttribute('aria-label'),r=root();if(!l||!r)return null;var m=[].find.call(r.querySelectorAll('[aria-label]'),function(x){return x.getAttribute('aria-label')===l});return m||null}
  function retry(fn){[0,60,250,600].forEach(function(t){setTimeout(fn,t)})}
  function restoreInside(){var r=root();if(!isOpen(r)||!lost())return;var t=resolve(intended)||resolve(lastInside)||r.querySelector('h2.upcart-header-text');if(t)t.focus()}
  function setup(r){
    if(r.__a11yV4)return;r.__a11yV4=1;
    r.addEventListener('focusin',function(e){
      var p=r.querySelector('.upcart-cart'),t=e.composedPath?e.composedPath()[0]:e.target;
      if(!p||!p.contains(t))return;
      var want=resolve(intended);
      if(want&&t!==want&&Date.now()-intendedAt<2000&&t.getAttribute('aria-label')==='Close cart'){setTimeout(function(){var w=resolve(intended);if(w)w.focus()},0);return}
      lastInside=t;
    },true);
    r.addEventListener('keydown',function(e){
      if(e.key!=='Tab'||!isOpen(r))return;
      var f=focusables(r),a=r.activeElement,i=f.indexOf(a);if(i<0)return;
      intended=f[(i+(e.shiftKey?-1:1)+f.length)%f.length];intendedAt=Date.now();
      if(!e.defaultPrevented&&a.classList.contains('upcart-product-quantity-input')){e.preventDefault();intended.focus()}
    },true);
    r.addEventListener('focusout',function(e){if(isOpen(r)&&!e.relatedTarget)retry(restoreInside)},true);
    new MutationObserver(function(){clearTimeout(tt);tt=setTimeout(tick,80)}).observe(r,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  }
  function dedupe(r){
    r.querySelectorAll('.upcart-product-title-link').forEach(function(tl){
      var row=tl.parentElement;for(var k=0;k<6&&row&&row.querySelectorAll('a[href]').length<2;k++)row=row.parentElement;if(!row)return;
      row.querySelectorAll('a[href]').forEach(function(a){if(a!==tl&&a.getAttribute('href')===tl.getAttribute('href')&&!(a.textContent||'').trim()){if(a.getAttribute('aria-hidden')!=='true')a.setAttribute('aria-hidden','true');if(a.getAttribute('tabindex')!=='-1')a.setAttribute('tabindex','-1')}});
    });
  }
  d.addEventListener('focusin',function(e){var h=host();if(h&&(e.target===h||h.contains(e.target)))return;if(!isOpen(root()))opener=e.target},true);
  function clickOpener(e){var h=host(),b=e.target&&e.target.closest&&e.target.closest('button,a[href],[role=button],input[type=submit]');if(!b||(h&&(b===h||h.contains(b))))return;if(!isOpen(root()))opener=b}
  d.addEventListener('pointerdown',clickOpener,true);d.addEventListener('click',clickOpener,true);
  d.addEventListener('keydown',function(e){var r=root();if(e.key==='Escape'&&isOpen(r)&&lost()){var c=r.querySelector('[aria-label="Close cart"]');if(c){e.preventDefault();c.click()}}},true);
  function tick(){
    var r=root();if(!r)return;setup(r);dedupe(r);
    var o=isOpen(r);
    if(o&&!wasOpen)wasOpen=true;
    else if(!o&&wasOpen){wasOpen=false;intended=null;lastInside=null;var t=opener;retry(function(){if(lost()&&t&&t.isConnected&&t.getClientRects().length)t.focus()})}
  }
  tick();
  new MutationObserver(function(){clearTimeout(tt);tt=setTimeout(tick,80)}).observe(d.documentElement,{childList:true,subtree:true});
})();


/* a11y-audit-v3 (10/26 re-test: N5, N6, L3, B8, M5 focus) */
(function(){
  var d=document;
  function $$(s,r){return [].slice.call((r||d).querySelectorAll(s))}
  function set(el,a,v){if(el&&el.getAttribute(a)!==v)el.setAttribute(a,v)}
  /* N5: homepage collection-row titles are styled spans; expose them as level-2 headings */
  function rowHeads(){$$('.collection__title .title.h2, .dedup-title .title').forEach(function(t){if(t.closest('h1,h2,h3,h4,h5,h6,[role=heading]'))return;set(t,'role','heading');set(t,'aria-level','2')})}
  /* N6: mobile product h1 may still be fitted to one line, but wraps instead of being cut off */
  function pdpTitle(){$$('.pdp-h1').forEach(function(h){if(h.scrollWidth>h.clientWidth+1)h.classList.add('a11y-wrap')})}
  /* L3: full card title as a tooltip where it is truncated */
  function cardTitles(){$$('.card__heading a, .vb-card__title a, .vb-card__title').forEach(function(a){if(a.title)return;var t=(a.textContent||'').replace(/\s+/g,' ').trim();if(t)a.title=t})}
  /* B8: theme code re-adds native disabled on the blank PDP Add to cart; swap it back to aria-disabled */
  function cartBtn(){$$('.vb-ss__cart').forEach(function(b){
    var fix=function(){if(b.hasAttribute('disabled')){b.removeAttribute('disabled');set(b,'aria-disabled','true')}};fix();
    if(b.__a11yb8)return;b.__a11yb8=1;new MutationObserver(fix).observe(b,{attributes:true,attributeFilter:['disabled']});
    b.addEventListener('click',function(e){if(b.getAttribute('aria-disabled')==='true'){e.preventDefault();e.stopImmediatePropagation()}},true);
  })}
  function run(){[rowHeads,pdpTitle,cardTitles,cartBtn].forEach(function(f){try{f()}catch(e){}})}
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',run);else run();
  addEventListener('load',function(){setTimeout(run,300)});
  var q;new MutationObserver(function(){clearTimeout(q);q=setTimeout(run,250)}).observe(d.documentElement,{childList:true,subtree:true});
})();

/* a11y-audit-v4 (10/26: H1, N2, M3, L2, B5, M10, M5, L8) */
(function(){
  var d=document,mqRM=matchMedia('(prefers-reduced-motion: reduce)');
  function $$(s,r){return [].slice.call((r||d).querySelectorAll(s))}
  function set(el,a,v){if(el&&el.getAttribute(a)!==v)el.setAttribute(a,v)}
  var live;function say(m){if(!live){live=d.createElement('div');live.className='a11y-v4-live visually-hidden';live.setAttribute('aria-live','polite');live.setAttribute('role','status');d.body.appendChild(live)}live.textContent='';setTimeout(function(){live.textContent=m},120)}

  /* N2: announcement pause button is visible again; reduced motion starts paused */
  function annStart(){var b=d.querySelector('.a11y-ann-pause');if(b&&!b.__v4&&mqRM.matches&&b.getAttribute('aria-label')==='Pause announcements'){b.__v4=1;b.click()}}

  /* H1: hero pause button label follows state */
  function heroPause(){$$('slideshow-component.a11y-hero .slideshow__autoplay').forEach(function(b){if(!b.getAttribute('aria-label'))set(b,'aria-label','Pause slideshow');var c=b.closest('.slideshow__controls');if(c&&c.style.getPropertyValue('display')!=='block')c.style.setProperty('display','block','important');if(b.style.getPropertyValue('display')!=='inline-flex')b.style.setProperty('display','inline-flex','important')})}

  /* L2: real <button> for See all categories; the div keeps the theme's click handler (clicks bubble) */
  function megaBtn(){
    var t=d.querySelector('#shop-by-cat .mega-trigger');if(!t||t.__v4)return;t.__v4=1;
    var b=d.createElement('button');b.type='button';b.className='a11y-mega-btn';
    while(t.firstChild)b.appendChild(t.firstChild);t.appendChild(b);
    ['aria-controls','aria-expanded'].forEach(function(a){if(t.hasAttribute(a)){b.setAttribute(a,t.getAttribute(a));t.removeAttribute(a)}});
    t.removeAttribute('role');t.removeAttribute('aria-haspopup');t.removeAttribute('tabindex');
    var gs=Element.prototype.setAttribute,gg=Element.prototype.getAttribute;
    t.setAttribute=function(a,v){if(a==='aria-expanded'||a==='aria-controls'||a==='aria-haspopup'||a==='role'||a==='tabindex'){if(a==='aria-expanded'||a==='aria-controls')gs.call(b,a,v);return}return gs.call(t,a,v)};
    t.getAttribute=function(a){if(a==='aria-expanded'||a==='aria-controls')return gg.call(b,a);return gg.call(t,a)};
    t.addEventListener('focus',function(){b.focus()});
    b.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' ')e.stopPropagation()});
  }

  /* B5: filters swap the grid in place; restore focus to the toggled filter and announce the result count */
  function filters(){
    var root=d.querySelector('[data-vb-native-root]');if(!root||root.__v4)return;root.__v4=1;
    var content=root.querySelector('[data-vb-native-content]')||root,pending=null;
    function lab(el){var l=el.closest('label')||(el.id&&d.querySelector('label[for="'+el.id+'"]'));return l?(l.getAttribute('aria-label')||l.textContent).replace(/\(\s*\d+\s*\)/g,'').replace(/\s+/g,' ').trim():(el.getAttribute('aria-label')||'').trim()}
    root.addEventListener('change',function(e){var el=e.target;if(el&&el.matches&&el.matches('input,select'))pending={el:el,t:Date.now(),l:lab(el),on:el.checked,sel:el.tagName==='SELECT',name:el.name}},true);
    root.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('#vb-filters a[href], .vb-grid__toolbar a[href], [data-vb-native-content] .pagination a, [data-vb-native-content] a[href*="filter."]');
      if(a&&root.contains(a))pending={el:a,t:Date.now(),l:(a.getAttribute('aria-label')||a.textContent).replace(/\s+/g,' ').trim(),link:1};
      if(e.target.closest&&e.target.closest('[data-vb-filters-close]'))setTimeout(function(){var o=root.querySelector('[data-vb-filters-open]');if(o&&o.offsetParent)o.focus()},60);
      if(e.target.closest&&e.target.closest('[data-vb-filters-open]'))setTimeout(function(){var c=root.querySelector('[data-vb-filters-close]');if(c&&c.offsetParent)c.focus()},360);
    },true);
    d.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('vb-filters-open')){var c=root.querySelector('[data-vb-filters-close]');if(c){e.preventDefault();c.click()}}});
    var q=0;new MutationObserver(function(){if(!pending||q)return;if(Date.now()-pending.t>10000){pending=null;return}if(pending.el.isConnected)return;q=setTimeout(function(){q=0;
      var p=pending;if(!p)return;pending=null;if(d.activeElement&&d.activeElement!==d.body&&root.contains(d.activeElement))return;
      var target=null;
      if(!p.link)$$('#vb-filters input, #vb-filters select, .vb-grid__toolbar select',root).some(function(i){if((p.sel&&i.tagName==='SELECT'&&i.name===p.name)||(!p.sel&&lab(i)===p.l)){target=i;return true}});
      var cnt=root.querySelector('.vb-grid__count');
      if(!target||!target.offsetParent){target=cnt;if(target)target.setAttribute('tabindex','-1')}
      if(target)target.focus({preventScroll:!!(target!==cnt)});
      var n=cnt?cnt.textContent.replace(/\s+/g,' ').trim():'';
      say((p.sel?'Sorted. ':p.link?'':(p.on?'Filter applied: ':'Filter removed: ')+p.l+'. ')+n);
    },250)}).observe(content,{childList:true,subtree:true});
  }

  /* M10: on product pages the chat launcher hides while the purchase controls are on screen */
  function chatGuard(){
    if(d.documentElement.__v4chat||!('IntersectionObserver' in window))return;
    var zone=d.querySelector('variant-selects')||d.querySelector('.vb-ss');if(!zone)return;d.documentElement.__v4chat=1;
    var form=zone.closest('.product__info-wrapper,.product__info-container,.vb-ss')||zone;var seen=new Set();
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)seen.add(e.target);else seen.delete(e.target)});d.documentElement.classList.toggle('a11y-chat-off',seen.size>0)});
    [form].concat($$('.product-form__buttons,.vb-ss__cart')).forEach(function(el){io.observe(el)});
  }

  /* M5: UpCart savings green to 4.5:1, focus the heading on open */
  var GREEN=/rgb\(46, 168, 24\)|rgb\(40, 164, 92\)/;
  function upcart(){
    var h=d.getElementById('upCart'),r=h&&h.shadowRoot;if(!r)return;
    $$('span,p,div,strong,b',r).forEach(function(el){if(el.children.length>2)return;var c=getComputedStyle(el).color;if(GREEN.test(c))el.style.setProperty('color','#1d7a44','important')});
    if(r.__v4)return;r.__v4=1;var wasOpen=false;
    new MutationObserver(function(){var dlg=r.querySelector('[role=dialog]');var open=!!(dlg&&dlg.offsetParent!==null&&!dlg.inert&&getComputedStyle(dlg).visibility!=='hidden');
      if(open&&!wasOpen){setTimeout(function(){var hd=r.querySelector('[role=dialog] h2, [role=dialog] [class*=header] h1, [role=dialog] [class*=Header] h2');if(hd){if(!hd.hasAttribute('tabindex'))hd.setAttribute('tabindex','-1');hd.focus()}},250)}
      wasOpen=open;upcartColors()}).observe(r,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','inert']});
    function upcartColors(){$$('span,p,strong,b',r).forEach(function(el){if(el.children.length>2)return;if(GREEN.test(getComputedStyle(el).color))el.style.setProperty('color','#1d7a44','important')})}
  }

  function run(){[annStart,heroPause,megaBtn,filters,chatGuard,upcart].forEach(function(f){try{f()}catch(e){}})}
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',run);else run();
  addEventListener('load',function(){setTimeout(run,400)});
  var q2;new MutationObserver(function(){clearTimeout(q2);q2=setTimeout(run,300)}).observe(d.documentElement,{childList:true,subtree:true});
})();
;(function(){function f(){var e=document.querySelector('.mobile-google-rating');if(e&&e.getAttribute('role')!=='complementary'){e.setAttribute('role','complementary');e.setAttribute('aria-label','Google rating')}}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',f);else f()})();
;(function(){var CSS='.UpcartDesignSettings__cartTextSubduedColor,.UpcartDesignSettings__cartTextSubduedColor *{color:#4a4a4a!important;opacity:1!important}.upcart-upsells-button{background-color:#1d7a44!important;border-color:#1d7a44!important;color:#fff!important}';function lab(r){if(!r.querySelector('style.a11y-uc2')){var s=document.createElement('style');s.className='a11y-uc2';s.textContent=CSS;r.appendChild(s)}r.querySelectorAll('.upcart-upsells-button').forEach(function(b){if(b.style.getPropertyValue('background-color')!=='#1d7a44'){b.style.setProperty('background-color','#1d7a44','important');b.style.setProperty('border-color','#1d7a44','important');b.style.setProperty('color','#fff','important')}});r.querySelectorAll('select:not([aria-label])').forEach(function(sel){var card=sel.closest('.upcart-upsell-item-card,[class*="upsell"]')||sel.parentNode;var t=card&&card.querySelector('[class*="title"],[class*="Title"],a,h3,h4');var name=t&&t.textContent.trim();sel.setAttribute('aria-label','Choose style, color and size'+(name?' for '+name:''))})}var obs=null,root=null;function tick(){var h=document.getElementById('upCart'),r=h&&h.shadowRoot;if(!r)return;if(r!==root){root=r;if(obs)obs.disconnect();var tt;obs=new MutationObserver(function(){clearTimeout(tt);tt=setTimeout(function(){try{lab(r)}catch(e){}},100)});obs.observe(r,{childList:true,subtree:true})}try{lab(r)}catch(e){}}var k=0,iv2=setInterval(function(){tick();if(++k>120)clearInterval(iv2)},500);tick()})();
;(function(){var seen=null,n=0;var iv=setInterval(function(){n++;var h=document.getElementById('upCart'),r=h&&h.shadowRoot;if(r&&r!==seen){seen=r;var s=document.createElement('span');s.hidden=true;s.className='a11y-uc-ping';document.body.appendChild(s);setTimeout(function(){s.remove()},50)}if(n>120)clearInterval(iv)},500)})();
;/* a11y-ann-swipe: the strip is overflow:hidden (no keyboard-unreachable scroll area), so swipes press the arrow buttons */(function(){var s=document.querySelector('.announcement-bar .slider--everywhere');if(!s||s.__swipe)return;s.__swipe=1;var x0=null,y0=0;s.addEventListener('touchstart',function(e){var t=e.touches[0];x0=t.clientX;y0=t.clientY},{passive:true});s.addEventListener('touchend',function(e){if(x0===null)return;var t=e.changedTouches[0],dx=t.clientX-x0,dy=t.clientY-y0;x0=null;if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy))return;var b=document.querySelector('.announcement-bar-slider .slider-button--'+(dx<0?'next':'prev'));if(b&&!b.disabled)b.click()},{passive:true})})();
